import DummyApiProvider from "@/services/api/providers/DummyApiProvider";
import RestApiProvider from "@/services/api/providers/RestApiProvider";

export default () => {
  return process.env.VUE_APP_ENABLE_DUMMY_API ? new DummyApiProvider() : new RestApiProvider();
}
